document.addEventListener('DOMContentLoaded', () => {
  let currentUrl = location.href;

  // Funzione che aggiorna l'HTML
  const refreshSpecs = async () => {
    const container = document.getElementById('specs-container');
    if (!container) return;

    const sectionId = container.getAttribute('data-section-id');
    const url = new URL(window.location.href);
    
    // (Section Rendering API)
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString());
      const text = await response.text();
      
      // Estraiamo il nuovo HTML dalla risposta
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(text, 'text/html');
      const newContainer = newDoc.getElementById('specs-container');

      if (newContainer) {
        container.innerHTML = newContainer.innerHTML;
      }
    } catch (e) {
      console.error('Errore aggiornamento metafield:', e);
    }
  };

  // Osserviamo se l'URL cambia
  new MutationObserver(() => {
    if (location.href !== currentUrl) {
      currentUrl = location.href;
      refreshSpecs();
    }
  }).observe(document, { subtree: true, childList: true });
});
